export class ListSelectedSetLoadingAction {
  constructor(public loading: boolean = true) {}
}
